export { default as FlightDetailsCard } from './FlightDetailsCard.vue';
